import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { connect } from 'react-redux';
import {
  changeCustomerDetails,
  onSetCustomerErrors,
  setCustomerDetails,
} from '../../actions/orders';
import InputField from './InputField';
import Translation from '../../utilities/localizationUtility';
import { isValidEmail, isValidPhone } from '../../utilities/helperUtility';
import { stringToBoolean } from '../../utilities/conversionUtility';

function CustomerInfo(props) {
  const {
    getValidationFn,
    onChange,
    onSetCustomer,
    onSetErrors,
    order: {
      customerDetailsValidationErrors = [],
      customerDetails = {},
    },
    settings,
  } = props;
  const { setting, style: { body } } = settings;
  const t = useMemo(() => new Translation(settings), [settings]);
  const [customer, setCustomer] = useState(customerDetails);
  const requiredPhone = !stringToBoolean(setting.optional_phone_number);

  const setError = (field, message, errors) => {
    errors.push({ key: field, value: message, fieldChanged: false });
    return errors;
  };

  const validateDetails = useCallback(() => {
    const errors = [];

    if (!customer.name) {
      setError('name', t.key('cantBeBlankMessage'), errors);
    }
    if (!customer.email) {
      setError('email', t.key('cantBeBlankMessage'), errors);
    } else if (!isValidEmail(customer.email)) {
      setError('email', t.key('invalidFormatMessage'), errors);
    }
    if (requiredPhone && !customer.phone) {
      setError('phone', t.key('cantBeBlankMessage'), errors);
    } else if (!!customer.phone && !isValidPhone(customer.phone)) {
      setError('phone', t.key('invalidFormatMessage'), errors);
    }
    onSetCustomer(customer);
    onSetErrors(errors);
    return errors;
  }, [customer, onSetCustomer, onSetErrors, t, requiredPhone]);

  const onHandleChange = (field, value) => {
    setCustomer({ ...customer, ...{ [field]: value } });
  };

  const onBlur = (field) => {
    onChange(field, customer[field]);
  };

  useEffect(() => {
    getValidationFn(validateDetails);
  }, [getValidationFn, validateDetails]);

  return (
    <div>
      <div className="booking-customer-container" style={{ borderColor: body.color }}>
        <div className="customer-field-label">
          {t.key('customerInformation')}
        </div>
        <div className="booking-customer-fields pure-form">
          <InputField
            name="name"
            currentValue={customer.name}
            errors={customerDetailsValidationErrors}
            label={t.key('customerName')}
            style={body}
            onChange={(value) => onHandleChange('name', value)}
            onBlur={() => onBlur('name')}
          />
          <InputField
            name="email"
            currentValue={customer.email}
            errors={customerDetailsValidationErrors}
            label={t.key('customerEmail')}
            style={body}
            onChange={(value) => onHandleChange('email', value)}
            onBlur={() => onBlur('email')}
          />
          <InputField
            name="phone"
            currentValue={customer.phone}
            errors={customerDetailsValidationErrors}
            label={t.key('customerPhone')}
            style={body}
            onChange={(value) => onHandleChange('phone', value)}
            onBlur={() => onBlur('phone')}
          />
        </div>
      </div>
    </div>
  );
}

export default connect(
  ({ order, settings }) => ({
    order,
    settings,
  }),
  (dispatch) => ({
    onChange: (field, value) => dispatch(changeCustomerDetails({ field, value })),
    onSetCustomer: (customer) => dispatch(setCustomerDetails(customer)),
    onSetErrors: (errors) => dispatch(onSetCustomerErrors(errors)),
  }),
)(CustomerInfo);
